<template>
    <!-- Like button -->    
    <div class="modal-card" style="width: auto">
                    <section class="modal-card-body">  
                    <div class="container radley">
                <div class="columns is-centered">    
                    <div class="column">     
                            <div class="is-pulled-right">                        
                            <a @click="$parent.close()"><b-icon
                                pack="fas"
                                icon="times">
                            </b-icon></a>
                            </div>
                        <article class="media">
                            <figure class="media-left">
                            <div 
                            class="recipe-avatar image"
                            v-if="selectedRecipe.mainImage[0]" 
                            :style="{ backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/'+selectedRecipe.mainImage[0]+'?alt=media)' }">
                            </div>
                            <b-rate 
                                v-model="selectedRecipe.rating"
                                icon-pack="fas"
                                icon="star"
                                size="is-small"
                                :max="5" 
                                show-score="false"
                                disabled="true">
                            </b-rate>
                            </figure>
                            <div class="media-content">
                                <div class="content">
                                    <p><span class="is-size-2 caveat">{{selectedRecipe.name}}</span><br />
                                    <small>From the Kitchen of 
                                    <router-link :to="{name: 'Kitchen', params: {id: selectedRecipe.user_id}}">  
                                        <strong>{{selectedRecipe.kitchen_name}}</strong>
                                    </router-link>
                                    <!--{{created_at}}-->
                                    </small></p>
                                    <em class="text-line-breaks">{{selectedRecipe.subtitle}}</em>
                                </div>                                
                            </div>
                        </article>
                        <b-message type="is-primary" class="mt-20" v-if="selectedRecipe.quickreference">
                            <div class="media quickreference">
                                <div class="media-left">
                                <b-icon
                                    pack="fas"
                                    icon="lightbulb"
                                    size="is-large">
                                </b-icon>
                                </div>
                                <div class="media-content">
                                    {{selectedRecipe.quickreference}}
                                </div>
                            </div>            
                        </b-message>
                            <div class="content mt-20">
                                <div>
                                    <nav class="level">    
                                        <div class="level-item has-text-centered">    
                                            <div>    
                                                <p class="heading">Prep Time</p>    
                                                <p class="title"><span v-if="selectedRecipe.prepTime.hours > 0">{{selectedRecipe.prepTime.hours}} hr, </span>
                                                    <span v-if="selectedRecipe.prepTime.minutes > 0">{{selectedRecipe.prepTime.minutes}} min</span></p>
                                            </div>    
                                        </div>    
                                        <div class="level-item has-text-centered">    
                                            <div>    
                                                <p class="heading">Cook Time</p>    
                                                <p class="title"><span v-if="selectedRecipe.cookTime.hours > 0">{{selectedRecipe.cookTime.hours}} hr, </span>    
                                                    <span v-if="selectedRecipe.cookTime.minutes > 0">{{selectedRecipe.cookTime.minutes}} min</span></p>
                                            </div>    
                                        </div>    
                                        <div class="level-item has-text-centered">    
                                            <div>    
                                                <p class="heading">Servings</p>    
                                                <p class="title">{{selectedRecipe.servings}}</p>    
                                            </div>    
                                        </div>    
                                    </nav>    
                                </div> 
                                <div class="mt-20">
                                <div class="columns">
                                <div class="column is-4 ingredient-list">
                                <b-collapse
                                    class="card">
                                    <div
                                        slot="trigger"
                                        slot-scope="props"
                                        class="card-header recipe-header"
                                        role="button">
                                        <p class="card-header-title">
                                            Ingredients
                                        </p>
                                        <a class="card-header-icon">
                                            <b-icon
                                            pack="fas"
                                                :icon="props.open ? 'caret-up' : 'caret-down'">
                                            </b-icon>
                                        </a>
                                    </div>
                                    <div class="card-content">
                                        <div class="content"> 
                                                <table class="table is-striped">  
                                                <tbody>
                                                    <tr v-for="ingredient in selectedRecipe.ingredients" :key="ingredient.id">
                                                    <td>   
                                                    <div class="field">
                                                        <b-checkbox>
                                                            <span v-html="ingredient.amount"></span>&nbsp;<span v-if="ingredient.measurement">{{ingredient.measurement}},&nbsp;</span>{{ingredient.ingredient}}
                                                        </b-checkbox>
                                                    </div>                                                            
                                                    </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            <div class="mt-50" v-if="secondPart != null">           
                                                <h3 class="is-size-5 p-12">For the {{secondPart.name}}</h3>                      
                                                <table class="table is-striped">  
                                                <tbody>
                                                    <tr v-for="ingredient in secondPart.ingredients" :key="ingredient.id">
                                                    <td>   
                                                    <div class="field">
                                                        <b-checkbox>
                                                            <span v-html="ingredient.amount"></span>&nbsp;<span v-if="ingredient.measurement">{{ingredient.measurement}},&nbsp;</span>{{ingredient.ingredient}}
                                                        </b-checkbox>
                                                    </div>                                                            
                                                    </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div> 
                                        </div>
                                    </div>
                                </b-collapse>  
                                </div>
                                <div class="column is-8">
                                <b-collapse
                                    class="card">
                                    <div
                                        slot="trigger"
                                        slot-scope="props"
                                        class="card-header recipe-header"
                                        role="button">
                                        <p class="card-header-title">
                                            Instructions
                                        </p>
                                        <a class="card-header-icon">
                                            <b-icon
                                            pack="fas"
                                                :icon="props.open ? 'caret-up' : 'caret-down'">
                                            </b-icon>
                                        </a>
                                    </div>
                                    <div class="card-content">
                                        <div class="content">
                                            <!-- Post content -->    
                                            <div v-for="(item,index) in selectedRecipe.steps" :key="item.id">    
                                                <div v-if="item.image" class="columns">
                                                        <div class="column is-two-thirds step-flex">    
                                                            <div class="list-number"><span class="is-size-4">{{index + 1}}.&nbsp;</span></div>
                                                            <div class="step-content"><span>{{item.text}}</span></div>  
                                                        </div>    
                                                        <div class="column is-one-third">    
                                                            <img :src="'https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/'+item.image+'?alt=media'" style="width:100%;" />    
                                                        </div>   
                                                    </div>
                                                    <div v-else>
                                                        <div class="step-flex">    
                                                            <div class="list-number"><span class="is-size-4">{{index + 1}}.&nbsp;</span></div> 
                                                            <div class="step-content"><span>{{item.text}}</span></div> 
                                                        </div>   
                                                    </div>    
                                            </div> 
                                            <div class="mt-50" v-if="secondPart != null">
                                                <h3 class="is-size-5 p-12">For the {{secondPart.name}}</h3> 
                                                <div v-for="(item,index) in secondPart.steps" :key="item.id">    
                                                    <div v-if="item.image" class="columns">
                                                        <div class="column is-two-thirds step-flex">    
                                                            <div class="list-number"><span class="is-size-4">{{index + 1}}.&nbsp;</span></div>
                                                            <div class="step-content"><span>{{item.text}}</span></div>  
                                                        </div>    
                                                        <div class="column is-one-third">    
                                                            <img :src="'https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/'+item.image+'?alt=media'" style="width:100%;" />    
                                                        </div>   
                                                    </div>
                                                    <div v-else>
                                                        <div class="step-flex">    
                                                            <div class="list-number"><span class="is-size-4">{{index + 1}}.&nbsp;</span></div> 
                                                            <div class="step-content"><span>{{item.text}}</span></div> 
                                                        </div>   
                                                    </div>   
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-collapse> 
                                </div>
                                </div>
                                </div>
                                  
                                   
                                <div class="mt-20 has-text-centered image-slider">    
                                    <carousel 
                                    :navigationEnabled="true" 
                                    :perPage="1" 
                                    paginationColor="rgba(0, 0, 0, 0.25)">    
                                        <slide v-for="mainImage in selectedRecipe.mainImage" :key="mainImage.id">    
                                            <img :src="'https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/'+mainImage+'?alt=media'"  />   
                                            <div class="has-text-centered">{{selectedRecipe.name}}</div>
                                        </slide>   
                                    </carousel>    
                                </div> 
                                <div class="mt-20">
                                <div class="author-name is-capitalized is-size-3 has-text-centered">From the kitchen of <b>
                                <router-link :to="{name: 'Kitchen', params: {id: selectedRecipe.user_id}}"> {{selectedRecipe.kitchen_name}}</router-link></b></div>    
                                <div class="is-size-5 has-text-centered"><i class="sl sl-icon-clock"></i> {{created_at | moment("from") }}</div>    
                                </div>
                                <hr>    
        
                                <div class="" id="tagSection">    
                                  
                                    <span v-for="tag in selectedRecipe.tags" :key="tag.id">
                                    <router-link :to="{name: 'tagged', params: {id: tag}}">
                                    <b-tag type="is-dark" size="is-medium">#{{tag}}</b-tag>&nbsp;    
                                    </router-link>
                                    </span>
                                </div>   
                            </div>  
                        
                    </div>      
                </div>    
                </div>    
                    </section>                    
                </div>
</template>

<script>      
import { Carousel } from 'vue-carousel';
import moment from 'moment';
import db from "@/db";
export default {
    data() {
        return {
            created_at: String,
            sizes: 'small',
            secondPart: Object
        }
    }, 
    props: {
        selectedRecipe: {
            type: Object,
            required: true
        }
    },
    mounted() {
        this.created_at = moment(this.selectedRecipe.created_at.toDate()).fromNow();   
        if(this.selectedRecipe.secondPart != null) {
            db.collection("recipes")
            .doc(this.selectedRecipe.secondPart.id)
            .get()
            .then((docSnapshot) => {
            if (!docSnapshot.exists) {
                this.$router.replace("/");
            }
                this.secondPart = docSnapshot.data();
            });
        }
        else {
            this.secondPart = null;
        }
    },
    components: {
        Carousel
    },
};
</script>